export default "__VITE_ASSET__9b2e3fa3__"